export interface IFieldType {
  fieldType: string;
  description: string;
  protected: boolean;
  multiline: boolean;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export class FieldTypeModel {
  fieldType: string;
  description: string;
  protected: boolean;
  multiline: boolean;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IFieldType) {
    this.fieldType = data.fieldType;
    this.description = data.description;
    this.protected = data.protected;
    this.multiline = data.multiline;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
